import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { HttpErrorResponse } from '@angular/common/http';
import { RegionsModel } from '../../models/manageRegions/regions.model';
import { AuthGaurdService } from 'src/app/service/auth-gaurd.service';
import { ManageRegionsService } from '../../service/manage-regions.service';
import { NotificationService } from '../../service/notification.service';
import { NotificationType } from '../../enum/notification-type.enum';
import { Observable, Subscription } from 'rxjs';
import { FormControl } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { startWith, debounceTime, distinctUntilChanged, switchMap, map } from 'rxjs/operators';
import { TableColumn } from 'src/app/home/table/TableColumn';
import { ExportExcelService } from 'src/app/service/export-excel.service';
import { GlobalService } from 'src/app/service/global.service';

@Component({
  selector: 'app-manage-regions',
  templateUrl: './manage-regions.component.html',
  styleUrls: ['./manage-regions.component.css']
})

export class ManageRegionsComponent implements OnInit {

  public regionsModel = new RegionsModel('', '', '', '', '', null, '', null, '', [], [], [], '', '');
  public getCorpsList = new RegionsModel('', '', '', '', '', null, '', null, '', [], [], [], '', '');

  public areasData1: RegionsModel[] = [];
  public allRecords: RegionsModel[];
  public loggedinUser: string = '';
  public errorMessage: string = '';
  public sucessMessage: string = '';
  private subscriptions: Subscription[] = [];
  public checkedactive: boolean = false;
  public isTableExpanded = false;
  public showLoading: boolean;
  public isDisabledCorp: boolean = false;

  public orgMajorAreaName: string;
  public orgRegionName: string;
  public orgAreaName: string;

  public corpName: string = '';
  public mainCorpName: string = '';
  public corps: any = [];
  public checkUncheckAllCorps: boolean = false;

  public ma: boolean = true;
  public reg: boolean = false;
  public area: boolean = false;
  public corp: boolean = false;
  public btnDisabled: boolean = true;

  public expandedElementMajor: null;
  public expandedElementRegion: null;
  public expandedElementArea: null;

  public value: string = "";

  public majorAreaName: string;
  public regionName: string;
  public areaName: string;
  public isChecked: boolean = false;



  public resMajorArea: RegionsModel[] = [];
  public resRegion: RegionsModel[] = [];
  public resArea: RegionsModel[] = [];

  public myControl = new FormControl();
  public filteredMajorAreaOptions: Observable<any[]>;

  public myControlArea = new FormControl();
  public filteredAreasOptions: Observable<any[]>;

  public myControlRegions = new FormControl();
  public filteredRegionsOptions: Observable<any[]>;

  // GRID FRAMEWORK
  ordersTableColumns1: TableColumn[];
  ordersTableColumns2: TableColumn[];
  ordersTableColumns3: TableColumn[];
  ordersTableColumns4: TableColumn[];
  columnsData: any;
  pageColumnsData: any;
  actions: any;
  checkbox: any;
  actionButtons: any;

  public majorAreasData: RegionsModel[] = [];
  public regionsData: RegionsModel[];
  public areasData: RegionsModel[];
  public corpsData: RegionsModel[];
  public corpsFinalData: RegionsModel[];
  public excelRegionsList: RegionsModel[] = [];


  columnsExcelData: any;
  dataForExcel = [];
  ordersTableExcelHeaderColumns: TableColumn[];

  isAccessDisabled: boolean = false;

  constructor(private globalService: GlobalService, private manageRegionsService: ManageRegionsService, private http: HttpClient,
    public ete: ExportExcelService, private httpService: HttpClient, private notificationService: NotificationService) {
  }

  ngOnInit(): void {
    //Get Permissions
    this.isAccessDisabled = this.globalService._permissionCheck('manage-regions');

    this.initializeColumns();
    this.getMajorAreas();
    this.getExcelManageRegions();
    this.getAllAreas();
    this.getMajorAreasSearch();
    this.getRegionsSearch();
    this.getAreasSearch();
    this.initializeExcelHeaders();
  }

  initializeExcelHeaders(): void {
    this.httpService.get('../../../assets/json/excelHeaders.json').subscribe(
      data => {
        this.columnsExcelData = data;
        this.ordersTableExcelHeaderColumns = this.columnsExcelData.manageRegions;
      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      }
    );
  }

  exportExcel() {
    for (let js of this.excelRegionsList) {
      delete js.created_dt;
      delete js.created_by;
      delete js.updated_dt;
      delete js.updated_by;
      delete js.regionsList;
      delete js.areasList;
      delete js.corpsList;
      delete js.comment;
    }
    this.dataForExcel = [];
    let reportData = null;
    this.excelRegionsList.forEach((row: any) => {
      this.dataForExcel.push(Object.values(row));
    })
     reportData = {
      title: 'ManageRegions',
      data: this.dataForExcel,
      headers: Object.keys(this.ordersTableExcelHeaderColumns[0])
    }
    this.ete.exportExcel(reportData);
  }

  public getMajorAreas(): void {
    this.btnDisabled = true;
    this.subscriptions.push(
      this.manageRegionsService.getMajorAreas().subscribe(
        (response: RegionsModel[]) => {
          this.majorAreasData = response;
          this.majorAreasData = this.majorAreasData.filter((v, i) => this.majorAreasData.findIndex(item => item.majorarea == v.majorarea) === i);
        }, (errorResponse: HttpErrorResponse) => {
          var msg: any;
          msg = errorResponse;
          this.notificationService.sendNotification(NotificationType.ERROR, msg);
        }
      )
    );
  }

  public getExcelManageRegions(): void {
    this.btnDisabled = true;
    this.subscriptions.push(
      this.manageRegionsService.getExcelManageRegions().subscribe(
        (response: RegionsModel[]) => {
          this.excelRegionsList = JSON.parse(JSON.stringify(response));
        }, (errorResponse: HttpErrorResponse) => {
          var msg: any;
          msg = errorResponse;
          this.notificationService.sendNotification(NotificationType.ERROR, msg);
        }
      )
    );
  }

  public getMajorAreasSearch() {
    this.filteredMajorAreaOptions = this.myControl.valueChanges.pipe(
      startWith(''),
      debounceTime(400),
      distinctUntilChanged(),
      switchMap(val => {
        return this.filterMajorAreas(val || '')
      })
    )
  }

  filterMajorAreas(val: string): Observable<any[]> {
    //console.log("filterMajorAreas");
    return this.manageRegionsService.getAutoMajorAreasData()
      .pipe(
        map(response => response.filter(option => {
          this.resMajorArea = response;
          return option.majorarea.toLowerCase().indexOf(val.toLowerCase()) === 0
        }))
      )
  }

  public getSelectedMajorAreas(desc: string) {
    console.log("desc = " + desc);
    if (desc === null || desc === "") {
      return null;
    } else {
      return this.resMajorArea?.find(cat => cat.majorarea === desc).majorarea;
    }
  }

  public getRegionsSearch() {
    this.filteredRegionsOptions = this.myControlRegions.valueChanges.pipe(
      startWith(''),
      debounceTime(400),
      distinctUntilChanged(),
      switchMap(val => {
        return this.filterRegions(val || '')
      })
    )
  }

  filterRegions(val: string): Observable<any[]> {
    //console.log("filterRegions");
    return this.manageRegionsService.getAutoRegionsData()
      .pipe(
        map(response => response.filter(option => {
          this.resRegion = response;
          return option.region.toLowerCase().indexOf(val.toLowerCase()) === 0
        }))
      )
  }

  public getSelectedRegions(desc: string) {
    console.log("desc = " + desc);
    if (desc === null || desc === "") {
      return null;
    } else {
      return this.resRegion.find(cat => cat.region === desc).region;
    }
  }

  public getAreasSearch() {
    this.filteredAreasOptions = this.myControlArea.valueChanges.pipe(
      startWith(''),
      debounceTime(400),
      distinctUntilChanged(),
      switchMap(val => {
        return this.filterAreas(val || '')
      })
    )
  }

  filterAreas(val: string): Observable<any[]> {
    //console.log("filterAreas");
    return this.manageRegionsService.getAutoAreasData()
      .pipe(
        map(response => response.filter(option => {
          this.resArea = response;
          return option.area.toLowerCase().indexOf(val.toLowerCase()) === 0
        }))
      )
  }

  public getSelectedAreas(desc: string) {
    console.log("desc = " + desc);
    if (desc === null || desc === "") {
      return null;
    } else {
      return this.resArea.find(cat => cat.area === desc).area;
    }
  }



  public onEditMajorArea(data: RegionsModel, name): void {
    this.regionsModel = data;
    this.orgMajorAreaName = name;
    this.clickButton('openMajorAreaEdit');
  }

  public onUpdateMajorArea(): void {
   
    const formData = this.manageRegionsService.createUpForm(this.regionsModel, this.orgMajorAreaName);
    this.subscriptions.push(
      this.manageRegionsService.updateMajorArea(formData).subscribe(
        (response: RegionsModel) => {
          this.clickButton('closeEditMajorAreaModalButton');
          this.getMajorAreas();
          this.reloadDropdowns();
          this.notificationService.sendNotification(NotificationType.SUCCESS, `Major Area updated successfully`);
        }, (errorResponse: HttpErrorResponse) => {
          var msg: any;
          msg = errorResponse;
          this.notificationService.sendNotification(NotificationType.ERROR, msg);
        }
      )
    );
     
  }
  private reloadDropdowns() {
    this.getAllAreas();
    this.getMajorAreasSearch();
    this.getRegionsSearch();
    this.getAreasSearch();
  }
  public onEditRegion(data: RegionsModel, name): void {
    this.regionsModel = data;
    this.orgRegionName = name;
    this.clickButton('openRegionEdit');
  }
  public onUpdateRegion(): void {
    
    this.regionsModel.majorarea = this.majorAreaName;
    const formData = this.manageRegionsService.createUpForm(this.regionsModel, this.orgRegionName);
    this.subscriptions.push(
      this.manageRegionsService.updateRegion(formData).subscribe(
        (response: RegionsModel) => {
          this.clickButton('closeEditRegionModalButton');
          this.getRegions();
          this.reloadDropdowns();
          this.notificationService.sendNotification(NotificationType.SUCCESS, `Region updated successfully`);
        }, (errorResponse: HttpErrorResponse) => {
          var msg: any;
          msg = errorResponse;
          this.notificationService.sendNotification(NotificationType.ERROR, msg);
        }
      )
    );
     
  }
  public onEditArea(data: RegionsModel, name): void {
    this.regionsModel = data;
    this.orgAreaName = name;
    this.clickButton('openAreaEdit');
  }
  public onUpdateArea(): void {
   
    this.regionsModel.majorarea = this.majorAreaName;
    this.regionsModel.region = this.regionName;
    const formData = this.manageRegionsService.createUpForm(this.regionsModel, this.orgAreaName);
    this.subscriptions.push(
      this.manageRegionsService.updateArea(formData).subscribe(
        (response: RegionsModel) => {
          this.clickButton('closeEditAreaModalButton');
          this.getAreas();
          this.reloadDropdowns();
          this.notificationService.sendNotification(NotificationType.SUCCESS, `Area updated successfully`);
        }, (errorResponse: HttpErrorResponse) => {
          var msg: any;
          msg = errorResponse;
          this.notificationService.sendNotification(NotificationType.ERROR, msg);
        }
      )
    );
     
  }

  public onUpdate(): void {
   
    const formData = this.manageRegionsService.createUpdateForm(this.regionsModel, this.isDisabledCorp, this.mainCorpName);
    this.subscriptions.push(
      this.manageRegionsService.updateCorp(formData).subscribe(
        (response: RegionsModel) => {
          this.clickButton('closeUpdateButton');
          this.corps = [];
          this.corpName = '';
          this.btnDisabled = true;
          this.getCorps();
          this.reloadDropdowns();
          this.notificationService.sendNotification(NotificationType.SUCCESS, `Corp/s updated successfully`);
        }, (errorResponse: HttpErrorResponse) => {
          var msg: any;
          msg = errorResponse;
          this.notificationService.sendNotification(NotificationType.ERROR, msg);
        }
      )
    );
     
  }



  checkUncheckAll() {
    //this.regionsModel.status = "Yes";
    console.log("====================");
    console.log("this.corps.length === " + this.corps.length);
    this.corpName = '';
    if (this.corps.length > 1) {
      console.log("if");
      this.corps.forEach((value: any, index: any) => {
        //console.log('array value i ', value);
        this.isDisabledCorp = true;
        this.corpName = this.corpName + value + ',';
        console.log('Corp Names == ', this.corpName);
        this.regionsModel.corp = this.corpName;
      });
    } else if (this.corps.length === 0) {
      this.btnDisabled = true;
      console.log("else if");
      this.corps = [];
      this.corpName = '';
      this.regionsModel.corp = '';
    } else {
      this.btnDisabled = false;
      console.log("else");
      this.corps.forEach((value: any, index: any) => {
        //console.log('array value i ', value);
        this.isDisabledCorp = false;
        this.regionsModel.corp = value;
      });
    }
  }

  public insertMajorArea(majorareaForm: NgForm): void {
    if (majorareaForm.value.id.toString().length < 4) {
      this.notificationService.sendNotification(NotificationType.ERROR, 'Corp ID minimum length is 4');
    } else if (majorareaForm.value.id.toString().length > 4) {
      this.notificationService.sendNotification(NotificationType.ERROR, 'Corp ID maximum length is 4');
    } else {
      this.showLoading = true;
      console.log("majorareaForm.value 1 = " + JSON.stringify(majorareaForm.value));
      majorareaForm.value.majorarea = this.regionsModel.majorarea;
      majorareaForm.value.region = this.regionsModel.region;
      majorareaForm.value.area = this.regionsModel.area;
      console.log("majorareaForm.value 2 = " + JSON.stringify(majorareaForm.value));

      const formData = this.manageRegionsService.createForm(majorareaForm.value);
      this.subscriptions.push(
        this.manageRegionsService.addMajorArea(formData).subscribe(
          (response: RegionsModel) => {
            this.getMajorAreas();
            this.reloadDropdowns();
            this.clickButton('new-majorarea-close');
            this.notificationService.sendNotification(NotificationType.SUCCESS, `Added successfully`);
            majorareaForm.reset();
            this.showLoading = false;
          }, (errorResponse: HttpErrorResponse) => {
            this.showLoading = false;
            var msg: any;
            msg = errorResponse;
            this.notificationService.sendNotification(NotificationType.ERROR, msg);
          }
        )
      );
    }
  }

  public saveMajorArea(): void {
    this.clickButton('new-majorarea-save');
  }

  public clearUpdate(): void {
    //this.corps = [];
    //this.corpName = '';
    //this.regionsModel.corp = '';
    //this.isDisabledUpdate = true;
  }

  public getRegionsName(majorAreaName: string) {
    this.btnDisabled = true;
    this.majorAreaName = majorAreaName;
    this.getRegions();
  }

  public getAreasName(regionName: string) {
    this.btnDisabled = true;
    this.regionName = regionName;
    this.getAreas();
  }

  public getCorpsName(areaname: string, status: string) {
    this.btnDisabled = true;
    this.corps = [];
    this.corpName = '';
    this.regionsModel.corp = '';

    this.areaName = areaname;
    this.regionsModel.area = areaname;
    this.regionsModel.status = status;
    this.getCorps();
  }

  public getCorps(): void {

    console.log("this.majorAreaName = " + this.majorAreaName);
    const formData = this.manageRegionsService.getCorpsForm(this.majorAreaName, this.regionName, this.areaName);

    console.log("formData = " + formData);
    this.manageRegionsService.getCorps(formData).subscribe(
      (response: RegionsModel[]) => {
        this.allRecords = response;
        const filterValue = this.globalService._normalizeValue('Active');
        this.corpsData = response.filter(comm => this.globalService._normalizeValue(comm.status).startsWith(filterValue));
        this.corpsFinalData = response.filter(comm => this.globalService._normalizeValue(comm.status).startsWith(filterValue));
      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      }
    )
  }

  public getInactiveCorps(): void {
    this.corpsFinalData = this.allRecords;
  }
  public getActiveCorps(): void {
    this.corpsFinalData = this.corpsData;
  }

  changed(values: any) {
    console.log("changed===" + JSON.stringify(values.value.currentTarget.checked));
    this.isChecked = values.value.currentTarget.checked;
    //alert(evt.target.checked)
    if (values.value.currentTarget.checked == true) {
      this.getInactiveCorps();
    } else {
      this.getCorps();
    }
  }




  public getAreas(): void {
    this.subscriptions.push(
      this.manageRegionsService.getAreas(this.majorAreaName, this.regionName).subscribe(
        (response: RegionsModel[]) => {
          this.areasData = response as RegionsModel[];
        }, (errorResponse: HttpErrorResponse) => {
          var msg: any;
          msg = errorResponse;
          this.notificationService.sendNotification(NotificationType.ERROR, msg);
        }
      )
    );
  }

  public getRegions(): void {
    console.log("this.majorAreaName = " + this.majorAreaName);
    this.subscriptions.push(
      this.manageRegionsService.getRegions(this.majorAreaName).subscribe(
        (response: RegionsModel[]) => {
          this.regionsData = response as RegionsModel[];
          //console.log("this.dataSourceMajorRegions.data = " + JSON.stringify(this.dataSourceMajorRegions.data));
        }, (errorResponse: HttpErrorResponse) => {
          var msg: any;
          msg = errorResponse;
          this.notificationService.sendNotification(NotificationType.ERROR, msg);
        }
      )
    );
  }

  public getAllAreas(): void {
    this.subscriptions.push(
      this.manageRegionsService.getAllAreas().subscribe(
        (response: RegionsModel[]) => {
          this.areasData1 = response;
        }, (errorResponse: HttpErrorResponse) => {
          var msg: any;
          msg = errorResponse;
          this.notificationService.sendNotification(NotificationType.ERROR, msg);
        }
      )
    );
  }

  public doFilter = (value: string) => {
    //this.dataSourceMajorAreas.filter = value.trim().toLocaleLowerCase();
    if (value === "") {
      this.getMajorAreas();
    } else {
      this.btnDisabled = true;
      this.subscriptions.push(
        this.manageRegionsService.getMAreas(value).subscribe(
          (response: RegionsModel[]) => {
            this.majorAreasData = response;
            //console.log("this.dataSourceMajorAreas.data = " + JSON.stringify(this.dataSourceMajorAreas.data));
          },
          (errorResponse: HttpErrorResponse) => {
            //this.sendNotification(NotificationType.ERROR, errorResponse.error.message);
          }
        )
      );
    }
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }

  changeRegions(event: any) {
    console.log(event.target.value);
    this.value = event.target.value;
    if (this.value === '1') {
      this.ma = true;
      this.reg = false;
      this.area = false;
      this.corp = false;
    } else if (this.value === '2') {
      this.ma = false;
      this.reg = true;
      this.area = false;
      this.corp = false;
    } else if (this.value === '3') {
      this.ma = false;
      this.reg = false;
      this.area = true;
      this.corp = false;
    } else if (this.value === '4') {
      this.ma = false;
      this.reg = false;
      this.area = false;
      this.corp = true;
    }
  }



  fieldsChange(values: any): void {
    this.checkUncheckAllCorps = false;
    this.mainCorpName = values.value.currentTarget.defaultValue;
    this.regionsModel.corp = values.value.currentTarget.defaultValue;
    if (values.value.currentTarget.checked) {
      this.corps.push(values.value.currentTarget.defaultValue);
    } else {
      this.corps.forEach((value: any, index: any) => {
        if (value == values.value.currentTarget.defaultValue) this.corps.splice(index, 1);
      });
    }
    this.checkUncheckAll();
  }

  // GRID FRAMEWORK
  innerRowAction1(row: any) {
    console.log("innerRowAction1 = ", row.row.majorarea, "=== val  ", row.value);
    if (row.value === 'View') {
      this.getRegionsName(row.row.majorarea);
    }
    if (row.value === 'Update') {
      this.onEditMajorArea(row.row, row.row.majorarea);
    }
  }

  innerRowAction2(row: any) {
    console.log("innerRowAction ....", row);
    if (row.value === 'View') {
      this.getAreasName(row.row.region);
    }
    if (row.value === 'Update') {
      this.onEditRegion(row.row, row.row.region);
    }
  }

  innerRowAction3(row: any) {
    console.log("innerRowAction ....", row);
    if (row.value === 'View') {
      this.getCorpsName(row.row.area, row.row.status);
    }
    if (row.value === 'Update') {
      this.onEditArea(row.row, row.row.area);
    }
  }



  actionOnButton(action: any) {
    console.log("actionOnButton = " + action);
    if (action === "Add") {
      if (this.isAccessDisabled === true) {
        this.notificationService.sendNotification(NotificationType.WARNING, NotificationType.PERMISSIONS_MSG);
      } else {
        this.clickButton(action);
      }

    } else if (action === "Update") {
      if (this.isAccessDisabled === true) {
        this.notificationService.sendNotification(NotificationType.WARNING, NotificationType.PERMISSIONS_MSG);
      } else {
        this.clickButton(action);
      }
    }
  }

  private clickButton(buttonId: string): void {
    document.getElementById(buttonId).click();
  }

  update(user: any, values: any) {
    if (values.value.currentTarget.checked) {
      //this.selctedKpis.push(user.row);
    } else {
      //this.selctedKpis.forEach((value: any, index: any) => {
      //  if (value.kpi_name == user.row.kpi_name) this.selctedKpis.splice(index, 1);
      //});
    }
    // console.log('this.selctedKpis ', this.selctedKpis);
  }

  initializeColumns(): void {
    this.httpService.get('../../../assets/json/tableColumns.json').subscribe(
      data => {
        this.columnsData = data;
        this.ordersTableColumns4 = this.columnsData.ManageRegionsCorpData;
        this.ordersTableColumns3 = this.columnsData.ManageRegionsAreaData;
        this.ordersTableColumns2 = this.columnsData.ManageRegionsRegionsData;
        this.ordersTableColumns1 = this.columnsData.ManageRegionsMajorAreaData;
        //console.log("this.ordersTableColumns1 = "+this.ordersTableColumns1);
      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      }
    );

    this.actions = [
      {
        name: 'Update',
        dataKey: 'far fa-edit success f-25',
        position: 'left',
        isSortable: false,
        class: 'badge bg-success'
      },
      {
        name: 'Delete',
        dataKey: 'far fa-trash-alt danger f-25',
        position: 'left',
        isSortable: false,
        class: 'badge bg-danger'
      }
    ]

    this.checkbox = [
      {
        name: 'Select',
        dataKey: 'corp',
        position: 'right',
        isSortable: false
      }

    ]

    this.actionButtons = [
      {
        name: 'Add',
        class: 'btn btn-primary btn-xs'
      },
      {
        name: 'Update',
        class: 'btn btn-success btn-xs'
      }
    ]

  }

}
